<template>
  <div v-if="salespersonSalePaymentData">
    <ColumnChart :title="'Plasiyer Tahsilat Analiz Grafiği'"
                 :description="'Plasiyer Bazlı Tahsilat Grafiği'"
                 :column-chart-options="salespersonPaymentDataChartOptions"
                 :loading="salespersonSalePaymentDataLoading"
    ></ColumnChart>
  </div>
</template>

<script>
import ColumnChart from "@/components/shared/apex-charts/ColumnChart";
import {mapState} from "vuex";
import {numberConverter} from "../../../../helpers";
export default {
  name: "PlasiyerTahsilatAnalizGrafigi",
  components: { ColumnChart },
  computed : {
      ...mapState("dashboard",["salespersonSalePaymentData","salespersonSalePaymentDataLoading"]),
  },
  data () {
    return {
      salespersonPaymentDataChartOptions: {
        series: [],
        chartOptions: {
          noData: {
            text: "Veri yok",
            align: "center",
            verticalAlign: "middle",
          },
          chart: {
            toolbar: {
              show: true,
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '100%',
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 4,
            colors: ['transparent']
          },
          colors: ['#34c38f', '#556ee6', '#ff9f43', '#f46a6a'],
          xaxis: {
            categories: [],
            labels: {
              formatter: function (value) {
                return value;
              },
            },
            title: {
              text: 'Plasiyer Tahsilat Analiz Grafiği',
              style: {
                fontWeight: '800',
              },
            },
          },
          yaxis: {
            title: {
              text: 'Plasiyerlere Göre Dağılım',
              style: {
                fontWeight: '800',
              },
            },
            labels: {
              formatter: function (value) {
                return value;
              },
            },
          },
          grid: {
            borderColor: '#f1f1f1',
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return `${numberConverter(val)}` + " TRY"
              }
            }
          }
        }
      },
    }
  },
  methods: {
    numberConverter,
    async setChartSettings()
    {
      if (this.salespersonSalePaymentData.length > 0)
      {
        this.salespersonPaymentDataChartOptions.series = [
          {
            name: 'Tahsilat',
            data: [],
          },
          {
            name: "Satış",
            data: [],
          }

        ];
        let result = this.salespersonSalePaymentData;
        for (let i = 0; i < result.length; i++) {
          this.salespersonPaymentDataChartOptions.chartOptions.xaxis.categories.push(result[i].salesPersonName);
        }
        let tahsilatObject = this.salespersonPaymentDataChartOptions.series.find(item => item.name === 'Tahsilat');
        let satisObject = this.salespersonPaymentDataChartOptions.series.find(item => item.name === 'Satış');

        for (let i = 0; i < result.length; i++) {
          if (tahsilatObject) {
            tahsilatObject.data[i] = (result[i].paymentAmount)
          }
          if (satisObject) {
            satisObject.data[i] = (result[i].salesAmount);
          }

        }
      }
    }
  },
  watch: {
    async salespersonSalePaymentData(newVal) {
      if (newVal) await this.setChartSettings();
    }
  }
}
</script>



<!--<script>-->
<!--// import ColumnChart from "@/components/shared/apex-charts/ColumnChart.vue";-->
<!--import {mapState} from "vuex";-->
<!--import VueApexCharts from "vue-apexcharts";-->

<!--export default {-->
<!--  name: "PlasiyerTahsilatAnalizGrafigi",-->
<!--  components: { apexchart: VueApexCharts },-->
<!--  props: {-->
<!--    propData : {-->
<!--      type: Array,-->
<!--      required: true-->
<!--    }-->
<!--  },-->
<!--  data() {-->
<!--    return {-->
<!--      testCategories: [],-->
<!--      SalesAmount: [],-->
<!--      PaymentAmount: [],-->
<!--      chartSeries: [],-->
<!--      testData: this.propData,-->
<!--      // salespersonSalePaymentData: [],-->
<!--      series: [{-->
<!--        data: this.seriesComp-->
<!--      }],-->
<!--        chartOptions: {-->
<!--          noData: {-->
<!--            text: "Veri yok",-->
<!--            align: "center",-->
<!--            verticalAlign: "middle",-->
<!--          },-->
<!--          chart: {-->
<!--            toolbar: {-->
<!--              show: true,-->
<!--            }-->
<!--          },-->
<!--          plotOptions: {-->
<!--            bar: {-->
<!--              horizontal:false,-->
<!--              columnWidth: "100%",-->
<!--            }-->
<!--          },-->
<!--          dataLabels: {-->
<!--            enabled: false-->
<!--          },-->
<!--          stroke: {-->
<!--            show: true,-->
<!--            width: 4,-->
<!--            colors: ["transparent"]-->
<!--          },-->
<!--          colors: ['#34c38f', '#556ee6', '#ff9f43', '#f46a6a'],-->
<!--          xaxis: {-->
<!--            categories: [],-->
<!--          },-->
<!--          yaxis: {-->
<!--            title: {-->
<!--              text: "Plasiyerlere Göre Dağılım",-->
<!--              style: {-->
<!--                fontWeight: '700'-->
<!--              },-->
<!--            },-->
<!--            labels: {-->
<!--              formatter: function (val) {-->
<!--                return Math.round(val).toLocaleString();-->
<!--              }-->
<!--            }-->
<!--          },-->
<!--          grid: {-->
<!--            borderColor: "#f1f1f1"-->
<!--          },-->
<!--          fill: {-->
<!--            opacity: 1-->
<!--          },-->
<!--          tooltip: {-->
<!--            y: {-->
<!--              formatter: function (val) {-->
<!--                return val + "TRY";-->
<!--              }-->
<!--            }-->
<!--          },-->
<!--      }-->
<!--    }-->
<!--  },-->
<!--  computed: {-->
<!--    ...mapState("dashboard",["salespersonSalePaymentData","salespersonSalePaymentDataLoading"]),-->
<!--    seriesComp () {-->
<!--      console.log("series");-->
<!--      return this.propData.map(item => item.salesAmount)-->
<!--    },-->
<!--    catComp () {-->
<!--      // eslint-disable-next-line vue/no-side-effects-in-computed-properties-->
<!--      this.chartOptions.xaxis.categories = this.propData.map(item => item.salesPersonName)-->
<!--      console.log(this.propData);-->
<!--      return this.propData.map(item => item.salesPersonName)-->
<!--    },-->
<!--    setChartCategories() {-->
<!--      // eslint-disable-next-line vue/no-side-effects-in-computed-properties-->
<!--      this.testCategories = [];-->
<!--      if (this.salespersonSalePaymentData.length > 0) {-->
<!--         this.salespersonSalePaymentData.map((item) => {-->
<!--           // eslint-disable-next-line vue/no-side-effects-in-computed-properties-->
<!--          this.testCategories.push(item.salesPersonName)-->
<!--        });-->
<!--        // eslint-disable-next-line vue/no-side-effects-in-computed-properties-->
<!--      } else this.testCategories = [];-->
<!--      return this.testCategories;-->
<!--    },-->
<!--    setChartSeriesSalesAmount() {-->
<!--      // eslint-disable-next-line vue/no-side-effects-in-computed-properties-->
<!--      this.SalesAmount = [];-->
<!--      if (this.salespersonSalePaymentData.length > 0) {-->
<!--        this.salespersonSalePaymentData.map((item) => {-->
<!--          // eslint-disable-next-line vue/no-side-effects-in-computed-properties-->
<!--          this.SalesAmount.push(item.salesAmount)-->
<!--        });-->
<!--        // eslint-disable-next-line vue/no-side-effects-in-computed-properties-->
<!--      } else this.SalesAmount = [];-->
<!--      return this.SalesAmount;-->
<!--    },-->
<!--    setChartSeriesPaymentAmount() {-->
<!--      // eslint-disable-next-line vue/no-side-effects-in-computed-properties-->
<!--      this.PaymentAmount = [];-->
<!--      if (this.salespersonSalePaymentData.length > 0) {-->
<!--        this.salespersonSalePaymentData.map((item) => {-->
<!--          // eslint-disable-next-line vue/no-side-effects-in-computed-properties-->
<!--          this.PaymentAmount.push(item.paymentAmount)-->
<!--        });-->
<!--        // eslint-disable-next-line vue/no-side-effects-in-computed-properties-->
<!--      } else this.PaymentAmount = [];-->
<!--      return this.PaymentAmount;-->
<!--    }-->
<!--  },-->
<!--  mounted() {-->
<!--    console.log("veriler");-->
<!--    console.log(this.testData);-->
<!--    console.log(this.propData)-->
<!--    console.log(this.salespersonSalePaymentData);-->
<!--    if (this.setChartCategories.length > 0) console.log(this.setChartCategories);-->
<!--    else console.log("veri yok");-->
<!--  }-->
<!--}-->
<!--</script>-->

<style scoped>

</style>